import { render, staticRenderFns } from "./notRegisteredCustInfo.vue?vue&type=template&id=6934996f&scoped=true"
import script from "./notRegisteredCustInfo.vue?vue&type=script&lang=js"
export * from "./notRegisteredCustInfo.vue?vue&type=script&lang=js"
import style0 from "./notRegisteredCustInfo.vue?vue&type=style&index=0&id=6934996f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6934996f",
  null
  
)

export default component.exports